import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { parseISO } from '@client/core/utils/date';
import { User } from '@client/features/user/models/user';

/**
 * @deprecated Activity Log Comments feature is being removed from the software.
 */
export class ActivityLogComment {
  constructor(
    public readonly id: number,
    public readonly user: User,
    public readonly commentText: string,
    public readonly activityLogId: number,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {}
}

defineTransform(ActivityLogComment, (json: JsonResponse) => {
  return {
    activityLogId: json.activity_log_id,
    commentText: json.comment_text,
    user: fromJson(User, json.user),
    createdAt: parseISO(json.created_at),
    updatedAt: parseISO(json.updated_at),
  };
});
